"use client";

import * as React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faChevronLeft,
//   faChevronRight,
// } from "@fortawesome/pro-light-svg-icons";
import { DayPicker } from "react-day-picker";

import { cn } from "@/lib/utils";
import { buttonVariants } from "@/components/fluid-ui/button";

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("p-3", className)}
      classNames={{
        months: "flex flex-col items-center space-y-4",
        month: "space-y-4",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: "text-sm font-medium",
        nav: "space-x-1 flex items-center",
        nav_button: cn(
          buttonVariants({ variant: "ghost" }),
          "h-7 w-7 justify-center bg-transparent p-0 opacity-50 hover:opacity-100",
        ),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse space-y-1",
        head_row: "flex",
        head_cell:
          "text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]",
        row: "flex w-full mt-2",
        cell: "h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
        day: cn(
          "h-9 w-9 rounded-md p-0 text-center font-normal transition-colors hover:bg-gray-100 focus:bg-gray-100",
        ),
        day_button: cn(
          "h-9 w-9 rounded-md p-0 text-center font-normal transition-colors hover:bg-gray-100 focus:bg-gray-100 disabled:cursor-not-allowed",
        ),
        disabled: "opacity-50 cursor-not-allowed",
        ...classNames,
      }}
      // components={{
      //   IconLeft: ({ className, ...props }) => (
      //     <FontAwesomeIcon
      //       icon={faChevronLeft}
      //       className={cn("h-4 w-4", className)}
      //       {...props}
      //     />
      //   ),
      //   IconRight: ({ className, ...props }) => (
      //     <FontAwesomeIcon
      //       icon={faChevronRight}
      //       className={cn("h-4 w-4", className)}
      //       {...props}
      //     />
      //   ),
      // }}
      {...props}
    />
  );
}
Calendar.displayName = "Calendar";

export { Calendar };
